import React from 'react';
import './index.scss';
import SvgIcon from '@/pages/home/components/SvgIcon';
const CardBtn = (porps: any) => {
  let { type, onClick } = porps;
  return (
    <div className="dbg-card-btn" onClick={onClick}>
      <SvgIcon className="dbg-card-btn-icon" type={type} ></SvgIcon>
    </div>
  );
};

export default CardBtn;
